import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { GeoCity, GeoCountry } from '../../models/geo.model';

/**
 * Pluggable geo data source.
 * Swap LocalJsonGeoProvider for Strapi/HTTP implementations without changing UI.
 */
export interface GeoDataProvider {
  getCountries(): Observable<GeoCountry[]>;
  getCitiesByCountry(countryCode: string): Observable<GeoCity[]>;
  getPhoneCode(countryCode: string): Observable<string | null>;
  resolveCountryByCode(code: string): Observable<GeoCountry | null>;
  resolveCountryByName(name: string): Observable<GeoCountry | null>;
}

export const GEO_DATA_PROVIDER = new InjectionToken<GeoDataProvider>('GEO_DATA_PROVIDER');
